import React from "react";
import "./Lottery.css";
import img1 from "../../Assets/lottery-img1.jpg";
import img2 from "../../Assets/lottery-img2.png";
function Lottery() {
  return (
    <div  className="lottery">
      <div style={{ padding: "1rem" }} className="div-lot1">
        <div>
          <h1>THE LOTTERY SYSTEM</h1>
          <p>
            <br />
            <br />
            A way to reward players with real value, get a chance to be <br /> rewarded 
            an ETH every month. The more tokens you hold the < br /> better your chances
            are of winning, tokens can be counted as a < br /> share of the company. Sit
            back and enjoy the fruits of your investments. < br /> Since 3% of royalties is
            being added to the vault every year < br />it is growing exponentially
            assuring that the vault never runs out.
          </p>
          <h5 style={{ textAlign: "center", marginTop: "20px" }}>
          <br />
          <br />
            Verified Vault Address
          </h5>
          <h7 style={{  marginTop: "10px" }} className="Address-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href= "https://etherscan.io/address/0xd7510C2155Dd086Bb75F68C42D632075184fA731">0xd7510C2155Dd086Bb75F68C42D632075184fA731</a>
          </h7>
          
        </div>
        <img src={img1} alt="" />
      </div>
      <div style={{ padding: "1rem" }} className="div-lot2">
      <img src={img2} alt="" />
        <div >
          <h1 className="happ">THE SECONDARY SALES</h1>
          <p>
            We have a 12.5% royalties on Mystical Pets, 2.5% goes to OpenSea for
            their services. The rest of the 10% is used to make sure the project
            is in the best position for the next 5 years and to assure that
            everything runs as smoothly as possible.{" "}
          </p>
          <p style={{textAlign:'center',marginTop:'20px'}}>ORGANIZATIONS TO BE DONATED TO END OF EVERY YEAR</p>
          <table style={{maxWidth:'400px',marginLeft:'auto',marginRight:'auto',width:'100%'}}>
            <tbody>
              <tr>
                <td>Tree Canada</td>
                <td> <a href="https://treecanada.ca/">treecanada.ca</a></td>
              </tr>
              <tr><td>Anti Poaching</td><td><a href="https://iapf.org/">iapf.org</a></td></tr>
              <tr><td>End Homelessness</td><td><a href="https://caeh.ca/">aeh.ca</a></td></tr>
              <tr><td>Indigenious Communites</td><td><a href="https://canadahelps.org/">canadahelps.org</a></td></tr>
              <tr><td>Palestine Relief Fund</td><td><a href="https://pcrf.net/">pcrf.net</a></td></tr>
              <tr><td>Relief for Ukrainians</td><td><a href="https://www.projecthope.org/">ProjectHope</a></td> </tr>
            </tbody>
          </table>
          <p style={{marginTop:'20px'}}>At the end of every year, the communites from each section is cycled 
and new ones are researched so there is a flow for each organization</p>
          <h5 style={{ textAlign: "center", marginTop: "20px" }}>
            Verified Secondary Sales Address:
          </h5>
          <h7 style={{  marginTop: "10px" }} className="Address-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href= "https://etherscan.io/address/0xB1403416209F88467d86ABA1Aee7D4D2D817DFF2">0xB1403416209F88467d86ABA1Aee7D4D2D817DFF2</a>
          </h7>
        </div>
      </div>
    </div>
  );
}

export default Lottery;
